import React, { Component } from 'react';
import { dashboardActions, userActions } from '../../_actions';
import { connect } from 'react-redux';
import { RiFacebookFill, RiInstagramLine, RiTwitterLine } from "react-icons/ri";
import { BiEdit, BiX } from "react-icons/bi";
import LoadingOverlay from 'react-loading-overlay';
import PhysioSidebar from '../../components/PhysioSidebar/PhysioSidebar';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import EditPhysioProfileModel from './components/EditPhysioProfileModel'
import { Box, TextField } from '@mui/material';
import { FaRegFilePdf } from "react-icons/fa";
import Rating from '@mui/material/Rating';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.saveUserInfo = this.saveUserInfo.bind(this);
    this.saveUserPersonalAddr = this.saveUserPersonalAddr.bind(this);
    this.saveSocialMedia = this.saveSocialMedia.bind(this);
    this.inputChange = this.inputChange.bind(this);
    this.state = {
      isDisabledPersonal: true,
      isDisabledAddress: true,
      isDisabledSocialMedia: true,
      fieldsUser: {},
      errorsUser: {},
      fieldsSocialMedia: {},
      errorsSocialMedia: {},
      open: false,
      showMore: false
    };
    this.toggleShowMore = this.toggleShowMore.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.users.isPasswordUpdate) {
      return {
        ...nextProps,
        fieldsUser: {},
        errorsUser: {},
        fieldsSocialMedia: {},
        errorsSocialMedia: {},

      }
    } else if (nextProps.users.isDisabledPersonal) {
      return {
        ...nextProps,
        isDisabledPersonal: true,
        isDisabledAddress: true,
        isDisabledSocialMedia: true,
        // isDisabledPersonal: true
      }
    } else {
      return {
        ...nextProps,

      }
    }
  }


  inputChange = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    this.setState({ [name]: value });
    let fieldsUser = this.state.fieldsUser;
    let errorsUser = this.state.errorsUser;
    fieldsUser[name] = value;
    errorsUser[name] = "";
    // console.log(name, value);
    this.setState({ fieldsUser, errorsUser });
  }

  inputChangeSocialMedia = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    this.setState({ [name]: value });
    let fieldsSocialMedia = this.state.fieldsSocialMedia;
    let errorsSocialMedia = this.state.errorsSocialMedia;
    fieldsSocialMedia[name] = value;
    errorsSocialMedia[name] = "";
    // console.log(name, value);
    this.setState({ fieldsSocialMedia, errorsSocialMedia });
  }

  saveUserInfo(e) {
    e.preventDefault();
    if (this.handleValidationUserInfo()) {
      let { firstName, lastName, mobNo } = this.state.fieldsUser;
      this.props.dispatch(userActions.saveUserInfo({
        firstName: firstName,
        lastName: lastName,
        mobNo: mobNo
      }, this.props));
    }
  }

  handleValidationUserInfo = () => {
    let fieldsUser = this.state.fieldsUser;
    let errorsUser = {};
    let formIsValid = true;

    //firstName
    if (!fieldsUser["firstName"] || !fieldsUser["firstName"].match("^[A-Za-z]+(((\\'|\\-|\\.)?([A-Za-z])+))?$")) {
      formIsValid = false;
      errorsUser["firstName"] = "Please Enter Valid firstName!";
    }

    //lastName
    if (!fieldsUser["lastName"] || !fieldsUser["lastName"].match("^[A-Za-z]+(((\\'|\\-|\\.)?([A-Za-z])+))?$")) {
      formIsValid = false;
      errorsUser["lastName"] = "Please Enter Valid lastName!";
    }

    if (!fieldsUser["mobNo"]) {
      formIsValid = false;
      errorsUser["mobNo"] = "Please enter Mobile Number!";
    }

    // console.log("errorsUsererrorsUsererrorsUser", errorsUser);

    this.setState({ errorsUser: errorsUser });
    return formIsValid;
  }

  saveUserPersonalAddr(e) {
    e.preventDefault();
    if (this.handleValidationAddrInfo()) {
      let { street, city, state, country, postCode } = this.state.fieldsUser;
      this.props.dispatch(userActions.saveUserPersonalAddr({
        street: street,
        city: city,
        state: state,
        country: country,
        postCode: postCode
      }, this.props));
    }
  }


  handleValidationAddrInfo = () => {
    let fieldsUser = this.state.fieldsUser;
    let errorsUser = {};
    let formIsValid = true;


    //street
    if (!fieldsUser["street"] || fieldsUser["street"] === "") {
      formIsValid = false;
      errorsUser["street"] = "Cannot Be Empty";
    }

    //city
    if (!fieldsUser["city"] || fieldsUser["city"] === "") {
      formIsValid = false;
      errorsUser["city"] = "Cannot Be Empty";
    }

    //state
    if (!fieldsUser["state"] || fieldsUser["state"] === "") {
      formIsValid = false;
      errorsUser["state"] = "Cannot Be Empty";
    }

    //country
    if (!fieldsUser["country"] || fieldsUser["country"] === "") {
      formIsValid = false;
      errorsUser["country"] = "Cannot Be Empty";
    }

    //postCode
    if (!fieldsUser["postCode"] || fieldsUser["postCode"] === "") {
      formIsValid = false;
      errorsUser["postCode"] = "Cannot Be Empty";
    }

    // console.log("errorsUsererrorsUsererrorsUser", errorsUser);

    this.setState({ errorsUser: errorsUser });
    return formIsValid;
  }

  saveSocialMedia(e) {
    e.preventDefault();
    if (this.handleValidationSocialMedia()) {
      let { facebook, instagram, twitter, linkedin } = this.state.fieldsSocialMedia;
      this.props.dispatch(userActions.saveSocialMedia({
        facebook: facebook,
        instagram: instagram,
        twitter: twitter,
        linkedin: linkedin
      }, this.props));
    }
  }


  handleValidationSocialMedia = () => {
    let fieldsSocialMedia = this.state.fieldsSocialMedia;
    let errorsSocialMedia = {};
    let formIsValid = true;

    //facebook
    if (!fieldsSocialMedia["facebook"] || !fieldsSocialMedia["facebook"] === "") {
      formIsValid = false;
      errorsSocialMedia["facebook"] = "Please Enter Valid facebook!";
    }

    //instagram
    if (!fieldsSocialMedia["instagram"] || !fieldsSocialMedia["instagram"] === "") {
      formIsValid = false;
      errorsSocialMedia["instagram"] = "Please Enter Valid instagram!";
    }

    //twitter
    if (!fieldsSocialMedia["twitter"] || !fieldsSocialMedia["twitter"] === "") {
      formIsValid = false;
      errorsSocialMedia["twitter"] = "Please Enter Valid twitter!";
    }

    //linkedin
    if (!fieldsSocialMedia["linkedin"] || !fieldsSocialMedia["linkedin"] === "") {
      formIsValid = false;
      errorsSocialMedia["linkedin"] = "Please Enter Valid linkedin!";
    }

    // console.log("errorsUsererrorsUsererrorsUser", errorsSocialMedia);

    this.setState({ errorsSocialMedia: errorsSocialMedia });
    return formIsValid;
  }

  componentDidMount() {

    this.props.dispatch(dashboardActions.getPhysioProfile());
    window.scrollTo(0, 0)
  }

  updateProfile = (e) => {
    let { users } = this.props;
    let { getUserInfo } = users;
    this.setState({
      fieldsUser: getUserInfo,
      isDisabledPersonal: false,
    })
  }
  cancelProfile = (e) => {
    this.setState({
      isDisabledPersonal: true,
    })
  }

  updateProfileAddress = (e) => {
    let { users } = this.props;
    let { getUserInfo } = users;
    this.setState({
      fieldsUser: getUserInfo,
      isDisabledAddress: false,
    })
  }
  cancelProfileAddress = (e) => {
    this.setState({
      isDisabledAddress: true,
    })
  }
  updateSocialMedia = (e) => {
    let { users } = this.props;
    let { getSocialMediaById } = users;

    // console.log("getSocialMediaByIdgetSocialMediaById  ", getSocialMediaById);
    let currentData = {
      facebook: getSocialMediaById && getSocialMediaById.facebook ? getSocialMediaById.facebook : '',
      instagram: getSocialMediaById && getSocialMediaById.instagram ? getSocialMediaById.instagram : '',
      twitter: getSocialMediaById && getSocialMediaById.twitter ? getSocialMediaById.twitter : '',
      linkedin: getSocialMediaById && getSocialMediaById.linkedin ? getSocialMediaById.linkedin : '',
    }
    this.setState({
      fieldsSocialMedia: currentData,
      isDisabledSocialMedia: false,
    })
  }
  cancelSocialMedia = (e) => {
    this.setState({
      isDisabledSocialMedia: true,
    })
  }

  closeEditProfile = () => {
    this.setState({ open: false })
    // console.log(this.state.open)
  }
  openEditProfile = () => {
    this.setState({ open: true })
    // console.log(this.state.open)
  }


  toggleShowMore() {
    this.setState(prevState => ({
      showMore: !prevState.showMore
    }));
  }

  render() {
    let { users, user, dashboard } = this.props;
    let { loading, userData } = dashboard
    let { getUserInfo, getSocialMediaById } = users;



    let data = userData && userData.physioRatingList && userData?.physioRatingList.map((e) => e?.rating)
    const sum = data && data.length > 0 && data.reduce((acc, curr) => acc + curr, 0);
    console.log(userData)


    // const { userData } = this.props;
    const { showMore } = this.state;


    return (
      <div className='flex'>


        <PhysioSidebar />

        <EditPhysioProfileModel open={this.state.open} closeDrModel={this.closeEditProfile} />

        <div className='w-full flex'>

          <div className='p-2 w-full overflow-y-auto h-screen overflow-hidden'>
            <LoadingOverlay active={loading} className="temp001" spinner text='Please wait...' />

            <div className=' lg:px-10 px-4 py-4 bg-gray-200 rounded-md flex justify-between items-center'>
              <h1 className=' text-xl font-bold text-[#005F60]'>PROFILE</h1>
              <button onClick={this.openEditProfile} className=' font-bold bg-[#005F60] px-6 py-2 rounded-md cursor-pointer text-white hover:bg-[#005F30]'>Edit Profile</button>
            </div>

            <div className='md:flex gap-5 w-full md:space-y-0 space-y-2 pt-10'>
              <div>

                <img
                  className='md:w-40 w-full md:h-40 h-full rounded shadow-md'
                  src={userData?.imageLinkUrl||"https://i.postimg.cc/zf4HQ1gZ/profile.png"}
                  alt="Hospital Image"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src = "https://i.postimg.cc/zf4HQ1gZ/profile.png";
                  }}
                />
              </div>
              <div className='flex flex-col flex-1 space-y-1'>
                <div>
                  <p className=' text-2xl font-bold text-black'>{userData && userData?.name} <span className=' text-xl font-semibold'>({userData?.specializationId?.name?userData?.specializationId?.name:"--"})</span></p>
                </div>
                <div className=' text-md font-medium'>{userData?.iapMember?userData?.iapMember:"--"} </div>
                <div className=' text-md font-medium'>Year of Experience {userData?.yearOfExp?userData?.yearOfExp:"--"}</div>
                <div className=' text-md font-medium'>{userData?.college?userData?.college:"--"} {userData?.qualification?userData?.qualification:"--"} </div>
                {/* {sum && data.length > 0 && <Rating name="read-only" value={sum / data.length} precision={0.5} readOnly />} */}
                <div className="flex items-center">
                  <Rating name="read-only" value={Number((sum / data?.length).toFixed(2))} precision={0.5} readOnly />
                  <span className='pl-2 font-bold'>{sum && data?.length} Review</span>
                </div>

              </div>
              < div className='  flex-1'>
              <div className='flex flex-col space-y-1 text-sm'>
                <div className=' text-base font-bold'>Treatements</div>
                {userData && userData?.physioTreatmentList&&userData?.physioTreatmentList?.map((e,i)=>(
                  <>
                  <div key={i}  className=' text-sm '>{e.name }</div>
                  </>
                  ))}
              </div>
                  </div>
            </div>
            <div className=' w-full space-y-4 pt-10 pb-20'>
              <div className='px-4 py-4 bg-gray-200 rounded-md flex justify-between items-center'>
                <h1 className=' text-xl font-bold text-[#005F60]'>Other Information</h1>
              </div>

              <div className='grid xl:grid-cols-2 grid-cols-1 gap-4 py-6'>
                <div className='border shadow-md'>
                  <div className='flex items-center gap-6 p-4 bg-gray-200'>
                    <p className='text-lg font-bold'>Email</p>
                    :
                    <p className='text-md font-semibold'>{userData?.email}</p>
                  </div>
                  <div className='flex items-center gap-6 p-4 '>
                    <p className='text-lg font-bold'>Contact Number</p>
                    :
                    <p className='text-md font-semibold'> {userData?.mobNo?userData?.mobNo:"--"}</p>
                  </div>
                  <div className='flex items-center gap-6 p-4 bg-gray-200'>
                    <p className='text-lg font-bold'>Alternate Number</p>
                    :
                    <p className='text-md font-semibold'>{userData?.alternateNo?userData?.alternateNo:"--"}</p>
                  </div>
                  <div className='flex items-center gap-6 p-4'>
                    <p className='text-lg font-bold'>Awards</p>
                    :
                    <p className='text-md font-semibold'>  {userData?.award?userData?.award:"--"}</p>
                  </div>
                  <div className='flex items-start gap-6 p-4 bg-gray-200'>
                    <p className='text-lg font-bold'>About us</p>
                    :
                    <p className='text-md font-semibold'>{userData?.aboutUs?userData?.aboutUs:"--"}</p>
                  </div>
                </div>
                <div className='border shadow-md'>
                  <div className='flex items-center gap-6 p-4 bg-gray-200'>
                    <p className='text-lg font-bold'>Address</p>
                    :
                    <p className='text-md font-semibold'> {userData?.address?userData?.address:"--"}</p>
                  </div>
                  <div className='flex items-center gap-6 p-4 '>
                    <p className='text-lg font-bold'>Landmark</p>
                    :
                    <p className='text-md font-semibold'>{userData?.line_1?userData?.line_1:"--"}</p>
                  </div>
                  <div className='flex items-center gap-6 p-4 bg-gray-200'>
                    <p className='text-lg font-bold'>Area</p>
                    :
                    <p className='text-md font-semibold'>  {userData?.line_2?userData?.line_2:"--"}</p>
                  </div>
                     <div className='flex items-center gap-6 p-4'>
                    <p className='text-lg font-bold'>District</p>
                    :
                    <p className='text-md font-semibold'> {userData?.district?userData?.district:"--"}</p>
                  </div>
                  <div className='flex items-center gap-6 bg-gray-200 p-4'>
                    <p className='text-lg font-bold'>City</p>
                    :
                    <p className='text-md font-semibold'> {userData?.cityId?.name?  userData?.cityId?.name:"--"}</p>
                  </div>
                  <div className='flex items-center gap-6 p-4 '>
                    <p className='text-lg font-bold'>State</p>
                    :
                    <p className='text-md font-semibold'>{userData?.state?userData?.state:"--"}</p>
                  </div>
                  <div className='flex items-center gap-6 bg-gray-200 p-4'>
                    <p className='text-lg font-bold'>Pincode</p>
                    :
                    <p className='text-md font-semibold'>{userData?.pinCode?userData?.pinCode:"--"}</p>
                  </div>
                </div>


              </div>

            </div>
          </div>

        </div>



      </div>
    );
  }
}
function mapStateToProps(state) {
  const { users, dashboard } = state;
  const { overview, getSocialMediaById } = users ? users : {};
  const { user } = overview ? overview : {};
  return {
    users,
    user,
    getSocialMediaById,
    dashboard,
  };
}
export default connect(mapStateToProps)(Dashboard);